<template>
  <v-sheet
    class="check-container"
    :color="getColor"
    :style="`border: 1px solid ${localItem.selected ? (textColor == 'success' ? 'var(--v-success-base)' : textColor) : '#d3d3d3'} !important`"
    @click="onClick"
  >
    <v-checkbox
      v-if="hasCheckbox"
      v-model="localItem.selected"
      :disabled="disabled"
      :color="textColor == 'success' ? 'var(--v-success-base)' : 'primary'"
      hide-details
      readonly
      class="mt-0 pt-0"
    >
      <template v-slot:label>
        <div class="centered-content">
          <p class="centered-text bold-text">{{ localItem.label }}</p>
          <p class="centered-text medium-bold-text" v-if="localItem.modality">Modalidad: {{ localItem.modality.description }}</p>
          <br v-if="localItem.modality">
          <p class="centered-text" v-if="localItem.term">{{ localItem.term.description }}</p>
        </div>
      </template>
    </v-checkbox>
    <span v-else v-html="localItem.label" :style="disabled ? 'color: #6A6A6A87' : ''"></span>
    <v-chip v-if="hasPriceText" :disabled="disabled" label :light="disabled" :color="disabled ? '' : color" :text-color="textColor" class="align-self-center fit-content">{{ localItem.amount | $currency }}</v-chip>
  </v-sheet>
</template>

<script>
export default {
  name: 'SpecialCheck',
  props: {
    item: { type: Object, default:() => ({label: '', amount: 0, selected: false}) },
    color: { type: String, default: 'primary' },
    textColor: String,
    disabled: { type: Boolean, default: false},
    hasCheckbox: { type: Boolean, default: true},
    hasPriceText: { type: Boolean, default: true}
  },
  data() {
    return {
      localItem: this.item,
    }
  },
  watch: {
    item(val) {
      this.localItem = val
    }
  },
  methods: {
    onClick() {
      if (!this.disabled) {
        this.localItem.selected = this.hasCheckbox ? !this.localItem.selected : this.localItem.selected
        this.$emit('updateItem')
      }
    }
  },
  computed: {
    getColor() {
      return this.localItem.selected && !this.textColor ? '#d9e2fa' : 'white'
    }
  }
}
</script>

<style lang="sass" scoped>
  .check-container
    height: fit-content
    display: flex
    cursor: pointer
    flex-flow: row nowrap
    justify-content: space-between
    border-radius: 5px
    padding: 10px 10px
    border: 1px solid #d3d3d3 !important
  .centered-content
    display: flex
    flex-direction: column
    align-items: flex-start
    justify-content: top
    text-align: left
    padding: 8px
  .centered-text
    margin: 0
    white-space: normal
  .bold-text
    font-weight: bold
  .medium-bold-text
    font-style: italic
    font-size: 0.9em
  .fit-content
    min-width: 40%
</style>
